
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./TeacherList.css";

const staffMembers = [
  { serial: 1, name: "DR KAJAL JADHAV", designation: "PRINCIPAL" },
  { serial: 2, name: "MR ENOCH MORDE", designation: "TGT" },
  { serial: 3, name: "MRS SUNITA PERE", designation: "TGT" },
  { serial: 4, name: "MR RAHUL WANKHEDE", designation: "TGT" },
  { serial: 5, name: "MRS VARSHARANI MESHRAM", designation: "TGT" },
  { serial: 6, name: "MRS REVATI MUKTEWAR", designation: "TGT" },
  { serial: 7, name: "MRS RAGITHA N PILLAI", designation: "TGT" },
  { serial: 8, name: "MS SHEETAL SUBHASH SODHI", designation: "TGT" },
  { serial: 9, name: "MRS NEHA DUBEY", designation: "TGT" },
  { serial: 10, name: "MRS SHEETAL RODE", designation: "TGT" },
  { serial: 11, name: "MRS KANCHAN VAIDYA", designation: "TGT" },
  { serial: 12, name: "MS TELESHWAREE CHAURWAR", designation: "TGT" },
  { serial: 13, name: "MS PRANALI RAUT", designation: "TGT" },
  { serial: 14, name: "MRS RUCHI", designation: "TGT" },
  { serial: 15, name: "MRS POONAM PANDEY", designation: "TGT" },
  { serial: 16, name: "MS PARUL MISHRA", designation: "TGT" },
  { serial: 17, name: "MRS POOJA KUMARI", designation: "TGT" },
  { serial: 18, name: "MRS VARSHA DIXIT", designation: "PRT" },
  { serial: 19, name: "MS PRADNYA TEPALE", designation: "PRT" },
  { serial: 20, name: "MRS SONAL ANANT SUBHEDAR", designation: "PRT" },
  { serial: 21, name: "MRS SEEMA KUMARI", designation: "PRT" },
  { serial: 22, name: "MRS SANGEETA HANS", designation: "PRT" },
  { serial: 23, name: "MRS NAJMUS SEHER", designation: "PRT" },
  { serial: 24, name: "MS POOJA ADMANE", designation: "PRT" },
  { serial: 25, name: "MRS SURAMMYA KONHER", designation: "PRT" },
  { serial: 26, name: "MRS PUSHPITA BOSE", designation: "PRT" },
  { serial: 27, name: "MS GEHANA PANDIYA", designation: "PRT" },
  { serial: 28, name: "MRS MAMTA DEVI", designation: "NTT" },
  { serial: 29, name: "MRS MONICA RAJ", designation: "NTT" },
  { serial: 30, name: "MRS POORNIMA GAUTAM", designation: "NTT" },
  { serial: 31, name: "MRS PUNAM KARIYE", designation: "Special Educator" },
  { serial: 32, name: "MRS SARIKA PRAVIN ZADE", designation: "Office Supritendent" },
  { serial: 33, name: "MR PRASHANT SORMARE", designation: "ACCT ASSIT" },
  { serial: 34, name: "MS SHRADDHA KANOJIYA", designation: "CLERK" },
  { serial: 35, name: "MR NIKIT JADHAV", designation: "CLERK" },
  { serial: 36, name: "MR YASH BARTINE", designation: "LAB ATTEN" },
  { serial: 37, name: "MR SURESH GAJGHATE", designation: "PEON" },
  { serial: 38, name: "MRS SANDHYA NIMBODKAR", designation: "AYAH" },
  { serial: 39, name: "MS LAXMI GAURISHANKAR", designation: "AYAH" },
  { serial: 40, name: "MR PANKAJ KUMRE", designation: "PEON" },
  { serial: 41, name: "MRS SUJATA HADKE", designation: "AYAH" },
  { serial: 42, name: "MR OMPRAKASH MARSHETTIWAR", designation: "PEON" },
  { serial: 43, name: "MR SURESH KUMRE", designation: "PEON" },
  { serial: 44, name: "MR PARAS AHIRWAR", designation: "PEON" },
  { serial: 45, name: "MR MANGESH DUPARE", designation: "PEON" },
  { serial: 46, name: "MR AKASH CHITRIV", designation: "PEON" },
  { serial: 47, name: "MRS YOGITA KOKARDE", designation: "PEON" },
  { serial: 48, name: "MR MAHADEV", designation: "WATCHMAN" },
  { serial: 49, name: "MR RAHUL NISTANE", designation: "WATCHMAN" },
  { serial: 50, name: "MR SATISH CHAUHAN", designation: "WATCHMAN" }
];

const visitingStaff = [
  { serial: 51, name: "MRS S MADUMITHA", designation: "TGT" },
  { serial: 52, name: "MRS RAMYA", designation: "TGT" },
  { serial: 53, name: "MS JASMEET KAUR PARMAR", designation: "TGT" }
];

function TeacherTable({ members, startNumber = 1 }) {
  return (
    <div className="teacher-table-wrapper">
      <table className="teacher-table">
        <thead>
          <tr>
            <th>Ser. No.</th>
            <th>Name</th>
            <th>Designation</th>
          </tr>
        </thead>

        <tbody>
          {members.map((member, index) => (
            <tr key={member.serial}>
              <td>
                <span className="teacher-serial">
                  {member.serial || startNumber + index}
                </span>
              </td>
              <td className="teacher-name">{member.name}</td>
              <td>
                <span className="teacher-designation">
                  {member.designation}
                </span>
              </td>
            </tr>
          ))}

          {members.length === 0 && (
            <tr>
              <td colSpan="3" className="teacher-empty">
                No staff members found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function TeacherList() {
  const [search, setSearch] = useState("");
  const [designation, setDesignation] = useState("ALL");

  const allStaff = useMemo(
    () => [...staffMembers, ...visitingStaff],
    []
  );

  const designations = useMemo(
    () => [...new Set(allStaff.map((member) => member.designation))].sort(),
    [allStaff]
  );

  const filterStaff = (members) =>
    members.filter((member) => {
      const matchesSearch =
        member.name.toLowerCase().includes(search.toLowerCase()) ||
        member.designation.toLowerCase().includes(search.toLowerCase());

      const matchesDesignation =
        designation === "ALL" || member.designation === designation;

      return matchesSearch && matchesDesignation;
    });

  const filteredRegular = filterStaff(staffMembers);
  const filteredVisiting = filterStaff(visitingStaff);

  const visibleCount = filteredRegular.length + filteredVisiting.length;

  return (
    <main className="teacher-list-page">

      {/* HERO */}
      <section className="teacher-hero">
        <div className="container">
          <div className="teacher-hero-content">

            <h1>
              Teacher <span>& Staff List</span>
            </h1>

            <p>
              Meet the dedicated educators and supporting staff
              who contribute to the learning and growth of our students.
            </p>

            <div className="teacher-breadcrumb">
              <Link to="/">Home</Link>
              <i className="bi bi-chevron-right"></i>
              <span>Teacher List</span>
            </div>
          </div>
        </div>
      </section>

      {/* STAFF LIST */}
      <section className="teacher-content-section">
        <div className="container">

          {/* SUMMARY */}
          <div className="teacher-summary-row mt-1">
            <div className="teacher-summary-card">
              <div className="teacher-summary-icon">
                <i className="bi bi-person-workspace"></i>
              </div>
              <div>
                <h3>50</h3>
                <p>Regular Staff</p>
              </div>
            </div>

            <div className="teacher-summary-card">
              <div className="teacher-summary-icon gold-icon">
                <i className="bi bi-person-check-fill"></i>
              </div>
              <div>
                <h3>03</h3>
                <p>Visiting Staff</p>
              </div>
            </div>

            <div className="teacher-summary-card">
              <div className="teacher-summary-icon dark-icon">
                <i className="bi bi-people-fill"></i>
              </div>
              <div>
                <h3>53</h3>
                <p>Total Staff Members</p>
              </div>
            </div>
          </div>

          {/* HEADING */}
          <div className="teacher-section-heading">
            <h2>Our Dedicated <span>Team</span></h2>
            <p>
              A list of teaching and non-teaching staff at
              Air Force School, Vayu Sena Nagar, Nagpur.
            </p>
          </div>

          {/* SEARCH AND FILTER */}
          <div className="teacher-filter-bar">
            <div className="teacher-search-box">
              <i className="bi bi-search"></i>
              <input
                type="text"
                placeholder="Search by staff name or designation..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch("")}
                  aria-label="Clear search"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              )}
            </div>

            <div className="teacher-select-box">
              <i className="bi bi-funnel-fill"></i>
              <select
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
              >
                <option value="ALL">All Designations</option>
                {designations.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <p className="teacher-result-count">
            Showing <strong>{visibleCount}</strong> of 53 staff members
          </p>

          {/* REGULAR STAFF */}
          <div className="teacher-list-card">
            <div className="teacher-table-heading">
              <div>
                <h3>Teaching & Non-Teaching Staff</h3>
              </div>
              <i className="bi bi-mortarboard-fill"></i>
            </div>

            <TeacherTable members={filteredRegular} />
          </div>

          {/* VISITING STAFF */}
          <div className="teacher-list-card visiting-staff-card">
            <div className="teacher-table-heading">
              <div>
                <h3>Visiting Staff</h3>
              </div>
              <i className="bi bi-person-video3"></i>
            </div>

            <TeacherTable members={filteredVisiting} />
          </div>

          {/* FOOTNOTE */}
          <div className="teacher-note">
            <i className="bi bi-info-circle-fill"></i>
            <p>
              The above list presents the teaching and non-teaching
              staff details provided by the school.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
}

export default TeacherList;
